






































































































import { Component, Prop, Vue } from "vue-property-decorator";
import MonitoringTransfusiSvc from "@/services/MonitoringTransfusiService";
import MonitoringTransfusiTtvDialog from "./MonitoringTransfusiTtvDialog.vue";
import { getEwssColor } from "@/utils/ewss";
import { appModule } from "@/store/modules/app";
import moment from "moment";

@Component({
  components: { MonitoringTransfusiTtvDialog }
})
export default class MonitoringTransfusiTtvTimeline extends Vue {
  @Prop() monitoring!: any;
  @Prop({ default: false }) readonly!: boolean;

  showTtvDialog = false;
  editingTtv: any = null;

  ttvHeaders = [
    { text: "Fase", value: "fase", width: "110px" },
    { text: "Waktu", value: "waktu_pengukuran", width: "100px" },
    { text: "Min ke", value: "menit_ke", width: "60px" },
    { text: "TD", value: "td_formatted", width: "80px" },
    { text: "Nadi", value: "nadi", width: "60px" },
    { text: "Suhu", value: "suhu", width: "55px" },
    { text: "RR", value: "respirasi", width: "50px" },
    { text: "SpO2", value: "spo2", width: "60px" },
    { text: "EWS", value: "ewss", width: "55px", sortable: false },
    { text: "Keluhan", value: "keluhan" },
    { text: "Aksi", value: "actions", sortable: false, width: "80px" },
  ];

  get sortedTtvs(): any[] {
    if (!this.monitoring || !this.monitoring.ttvs) return [];
    return [...this.monitoring.ttvs].sort((a: any, b: any) => {
      return new Date(a.waktu_pengukuran).getTime() - new Date(b.waktu_pengukuran).getTime();
    });
  }

  get seedWaktuTtv(): string | null {
    const terakhir = this.sortedTtvs.length
      ? this.sortedTtvs[this.sortedTtvs.length - 1].waktu_pengukuran
      : null;

    if (terakhir) {
      return moment(terakhir).add(15, "minutes").format("YYYY-MM-DD HH:mm:ss");
    }
    if (this.monitoring && this.monitoring.mulai_at) {
      return moment(this.monitoring.mulai_at).format("YYYY-MM-DD HH:mm:ss");
    }
    return null;
  }

  get suggestedFase(): string {
    if (!this.monitoring) return "pre";
    if (!this.monitoring.mulai_at) return "pre";
    if (this.monitoring.selesai_at) return "post";
    return "intra";
  }

  isTdAlert(item: any): boolean {
    if (item.tekanan_darah_sistolik < 90) return true;
    // Check drop from baseline
    const baseline = this.sortedTtvs.find((t: any) => t.fase === "pre");
    if (baseline && baseline.id !== item.id) {
      return (baseline.tekanan_darah_sistolik - item.tekanan_darah_sistolik) >= 20;
    }
    return false;
  }

  ewssColor(kategori: string): string {
    return getEwssColor(kategori);
  }

  ttvTrend(field: string): number[] {
    return this.sortedTtvs
      .filter((t: any) => t[field] !== null && t[field] !== undefined)
      .map((t: any) => t[field]);
  }

  editTtv(item: any) {
    this.editingTtv = item;
    this.showTtvDialog = true;
  }

  async hapusTtv(item: any) {
    if (!confirm("Hapus data TTV ini?")) return;
    try {
      const resp = await MonitoringTransfusiSvc.deleteTtv(this.monitoring.id, item.id);
      if (resp?.data?.status == "1") {
        appModule.NoticeDelay("Berhasil menghapus TTV");
        this.$emit("saved");
      }
    } catch {
      // handled
    }
  }

  onTtvSaved() {
    this.editingTtv = null;
    this.$emit("saved");
  }

  formatTime(val: string) {
    if (!val) return "-";
    return moment(val).format("DD/MM HH:mm");
  }
}
